export class CandidatesDetails {
	userName: '';
	name: '';
	phone: '';
	email: '';
	gender: '';
	status: '';
	dob: '';
	resume: '';
	address: {
		addressLine1: string;
		landmark: string;
		pincode: string;
		city: {
			name: string;
		};
		district: {
			name: string;
		};
		state: {
			name: string;
		};
		mandal: {
			name: string;
		};
		country: {
			name: string
		};
	} = {
		addressLine1: '',
		landmark: '',
		pincode: '',
		city: {
			name: ''
		},
		district: {
			name: ''
		},
		state: {
			name: ''
		},
		mandal: {
			name: ''
		},
		country: {
			name: ''
		},
	};
	languagesKnown: Array<any>;
	religion: {
		name: string;
	} = {
		name: ''
	};
	category: {
		name: string;
	} = {
		name: ''
	};
	education: [
		{
			education: {};
			details: string;
			supportingDocument: string;
		}
	];
	industrialExperience: Array<any>;
	trainingExperience: Array<any>;
}
